import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

/**
 * Redirects to /page-403 only for VPN / IP whitelist blocks (HTTP 403 HTML).
 * Business-rule blocks (e.g. terminated deal) use HTTP 422 with JSON and must not redirect here.
 */
@Injectable()
export class VpnInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && this.isVpnAccessDenied(event.status, event.body)) {
          this.router.navigate(['/page-403']);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (this.isVpnAccessDenied(error.status, error.error)) {
          this.router.navigate(['/page-403']);
        }
        return throwError(() => error);
      }),
    );
  }

  private isVpnAccessDenied(status: number, body: unknown): boolean {
    if (status !== 403) {
      return false;
    }

    // API JSON errors (deal read-only, permissions, etc.) — not a VPN block.
    if (body && typeof body === 'object' && (body as { status?: string }).status === 'error') {
      return false;
    }

    // Ip_check uses show_error() → HTML body or plain "Access forbidden!" text.
    if (typeof body === 'string') {
      return true;
    }

    // Empty / non-JSON 403 is treated as infrastructure access denial.
    return body == null || body === '';
  }
}

export const vpnInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: VpnInterceptor,
  multi: true,
};
